'use strict';

import { GLOBAL } from './Global';
import { MARKETING as MARKETING_PERMISSION_GROUPS } from '../PermissionsGroups';

const marketing_permissions_list = [];

for (const [key, value] of Object.entries(MARKETING_PERMISSION_GROUPS)) {
  marketing_permissions_list.push({
    action_list: value,
    element: key,
  });
}

const MARKETING = {
  can: [
    ...GLOBAL.can,
    ...marketing_permissions_list,
  ],
};

export {
  MARKETING,
};
